import { createTheme } from '@mui/material/styles';
import React from 'react';

declare module '@mui/material/styles/createPalette' {
  interface Palette {
    ranking: {
      up: PaletteColor;
      down: PaletteColor;
    };
  }
  interface PaletteOptions {
    ranking?: {
      up?: PaletteColorOptions;
      down?: PaletteColorOptions;
    };
  }
}
declare module '@mui/material/styles' {
  interface TypographyVariants {
    body3: React.CSSProperties;
  }

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    body3?: React.CSSProperties;
  }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    body3: true;
  }
}

const baseTheme = createTheme({
  components: {
    MuiUseMediaQuery: {
      defaultProps: {
        noSsr: true, // falseだと初回のmediaQueryがすべてfalse
      },
    },
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          body3: 'body2',
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          size: 'small',
          backgroundColor: '#fff',
        },
      },
    },
    MuiGrid: {
      styleOverrides: {
        root: {
          backgroundColor: '#fff',
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          dense: true,
          disablePadding: true,
        },
      },
    },
  },
  palette: {
    background: {
      default: '#f7f7f7',
      paper: '#fff',
    },
    ranking: {
      up: { main: '#192672' },
      down: { main: 'rgb(220, 0, 78)' },
    },
  },
  typography: {
    h1: {
      fontWeight: 500,
      fontSize: '1.5rem',
      letterSpacing: '0em',
    },
    h2: {
      fontWeight: 300,
      fontSize: '1.25rem',
      letterSpacing: '0em',
    },
    h3: {
      fontWeight: 300,
      fontSize: '1rem',
      letterSpacing: '0em',
    },
    body3: {
      fontSize: '0.625rem',
    },
    button: {
      textTransform: 'none',
    },
  },
});

export const theme = createTheme(baseTheme, {
  components: {
    MuiButton: {
      variants: [
        {
          props: { variant: 'outlined' },
          style: {
            color: '#0f165f',
          },
        },
      ],
    },
  },
  palette: {
    primary: {
      main: '#192672',
      light: '#3d4a8f',
      dark: '#0f165f',
    },
  },
});

export const themeSf = createTheme(baseTheme, {
  components: {
    MuiButton: {
      variants: [
        {
          props: { variant: 'outlined' },
          style: {
            color: '#003b00',
          },
        },
      ],
    },
  },
  palette: {
    primary: {
      main: '#006400',
      light: '#1a751a',
      dark: '#003b00',
    },
  },
});
